class RkbProductSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-rkb-slider-track]');
    this.section = this.closest('.rkb-product-slider');
    this.prev = this.section?.querySelector('[data-rkb-slider-prev]');
    this.next = this.section?.querySelector('[data-rkb-slider-next]');
    this.progress = this.querySelector('[data-rkb-slider-progress]');
    this.status = this.querySelector('[data-rkb-slider-status]');
    this.cards = [...this.querySelectorAll('.rkb-slider-card')];

    if (!this.track || !this.prev || !this.next) return;

    this.prev.addEventListener('click', () => this.move(-1));
    this.next.addEventListener('click', () => this.move(1));
    this.track.addEventListener('scroll', this.requestUpdate, { passive: true });
    this.track.addEventListener('keydown', this.onKeydown);
    this.track.addEventListener('pointerdown', this.onPointerDown);
    this.track.addEventListener('pointermove', this.onPointerMove);
    this.track.addEventListener('pointerup', this.onPointerUp);
    this.track.addEventListener('pointercancel', this.onPointerUp);
    this.track.addEventListener('click', this.preventDraggedClick, true);

    this.resizeObserver = new ResizeObserver(this.update);
    this.resizeObserver.observe(this.track);
    this.update();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  requestUpdate = () => {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = 0;
      this.update();
    });
  };

  move = (direction) => {
    const card = this.cards[0];
    const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
    const step = card ? (card.getBoundingClientRect().width + gap) * Math.max(1, Math.floor(this.track.clientWidth / card.getBoundingClientRect().width) - 1) : this.track.clientWidth * 0.8;
    this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
  };

  onKeydown = (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    this.move(event.key === 'ArrowLeft' ? -1 : 1);
  };

  onPointerDown = (event) => {
    if (event.pointerType === 'touch') return;
    this.dragStartX = event.clientX;
    this.dragStartScroll = this.track.scrollLeft;
    this.dragged = false;
    this.track.setPointerCapture(event.pointerId);
    this.track.classList.add('is-dragging');
  };

  onPointerMove = (event) => {
    if (this.dragStartX == null || event.pointerType === 'touch') return;
    const distance = event.clientX - this.dragStartX;
    if (Math.abs(distance) > 5) this.dragged = true;
    this.track.scrollLeft = this.dragStartScroll - distance;
  };

  onPointerUp = (event) => {
    if (this.dragStartX == null) return;
    this.dragStartX = null;
    this.track.classList.remove('is-dragging');
    if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
  };

  preventDraggedClick = (event) => {
    if (!this.dragged) return;
    event.preventDefault();
    event.stopPropagation();
    this.dragged = false;
  };

  update = () => {
    const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    const current = Math.min(max, Math.max(0, this.track.scrollLeft));
    const ratio = max > 0 ? current / max : 1;

    this.prev.disabled = current <= 2;
    this.next.disabled = current >= max - 2;
    this.progress?.style.setProperty('--rkb-slider-progress', `${Math.max(12, ratio * 100)}%`);

    if (this.status && this.cards.length) {
      const cardWidth = this.cards[0].getBoundingClientRect().width || 1;
      const visibleIndex = Math.min(this.cards.length, Math.round(current / cardWidth) + 1);
      this.status.textContent = `Showing product ${visibleIndex} of ${this.cards.length}`;
    }
  };
}

if (!customElements.get('rkb-product-slider')) {
  customElements.define('rkb-product-slider', RkbProductSlider);
}
